import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GET_VERSION, LOGIN_ENDPOINT } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "./Login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    localStorage.removeItem("access_token");
  }, []);
  const navigate = useNavigate();

  const validateForm = () => {
    let isValid = true;

    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!isValidEmail(email)) {
      setEmailError("Invalid email address");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else {
      setPasswordError("");
    }

    return isValid;
  };

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const response = await axiosInstance.post(`${LOGIN_ENDPOINT}`, {
          username: email,
          password: password,
        });

        if (response?.data?.error === "PasswordExpired") {
          navigate("/update-password", { state: { email: email } });
        }

        if (response?.data?.error === "IncorrectPassword") {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }

        response?.data?.access_token
          ? localStorage.setItem("is_valid", true)
          : localStorage.setItem("is_valid", false);

        localStorage.setItem("authenticated", true);
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("username", response.data.username);
        localStorage.setItem("userid", response.data.user_id);
      } catch (error) {
        console.log(error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.detail
        ) {
          toast.error(`Error: ${error.response.data.detail}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        } else {
          toast.error(`Error: ${error.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      }

      try {
        const response = await axiosInstance.get(GET_VERSION, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        localStorage.setItem("version", response.data.message);
        navigate("/home");
      } catch (error) {}
    } else {
      setFormError("Please fill in the required fields correctly");
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      {/* <video id="background_video" autoPlay loop muted>
        <source src="/videos/carpl_intro.mp4" type="video/mp4" />
      </video> */}
      <img
        src="/images/carpl_background.png"
        alt="carpl-background"
        style={{ position: "absolute", width: "100%", opacity: "0.3" }}
      ></img>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ position: "relative", left: "7rem", top: "10rem" }}
      >
        <div className="login-img-data">
          <div>
            <img src="images/carpl_logo.png" alt="Not found" />
          </div>

          <div className="login-header-data">
            Global Platform for Development, Testing &amp; Deployment of
            Advanced Radiology Analytics
          </div>
        </div>

        <div className="login-form-container">
          <div className="login-register-heading">
            <span style={{ fontWeight: 100 }}> LOGIN TO</span> ROUTER
          </div>
          <div className="input-container">
            {" "}
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-start align-items-center input-field-login">
                <div className="icon-input-field">
                  <i className="fa fa-user" aria-hidden="true"></i>{" "}
                </div>

                <div className="input-width-22rem ">
                  <TextField
                    // variant="standard"
                    autoFocus
                    id="username"
                    name="username"
                    size="small"
                    type={"email"}
                    placeholder="Username"
                    onChange={(e) => setEmail(e.target.value.trimStart())}
                    sx={{ width: "22rem" }}
                    InputProps={{
                      sx: {
                        color: "whitesmoke",
                        borderRadius: "0.5rem",
                        width: "22rem",
                        fontSize: "14px",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="error-span">{emailError}</div>
            </div>
            <div className="d-flex flex-column">
              {" "}
              <div className="password-container d-flex justify-content-start align-items-center input-field-login">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="icon-input-field">
                    <i className="fa fa-unlock-alt" aria-hidden="true" />
                  </div>
                  <div className="input-width-22rem">
                    <TextField
                      // variant="standard"
                      autoFocus
                      size="small"
                      id="username"
                      name="username"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value.trimStart())}
                      sx={{ width: "22rem" }}
                      InputProps={{
                        sx: {
                          color: "whitesmoke",
                          borderRadius: "0.5rem",
                          width: "22rem",
                          fontSize: "14px",
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="toggleView">
                  <i
                    className={!showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                    id="togglePassword"
                    style={{ marginLeft: "0.5rem" }}
                    onClick={handleClickShowPassword}
                  />
                </div>
              </div>
              <span className="error-span">{passwordError}</span>
            </div>
          </div>

          <button onClick={handleSubmit} className="login-button">
            LOGIN
          </button>
          <div className="register-text-container">
            <span style={{ color: "white" }}> New User?</span>{" "}
            <Link
              to="/SignUp"
              className="register-text"
              style={{ color: "#00c9d0", textDecoration: "none" }}
            >
              Click here to Register
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
